import Fullpage from '../utilities/fullpage.js';
import Marquee from '../utilities/marquee';

export default function workshopsSection(context) {

  // Get workshop sections
  const workshopSections = context.querySelectorAll("#workshop-sections section");
  if (!workshopSections.length) return;

  // Title animator
  const titleMarquee = new Marquee('#workshops-marquee', [...workshopSections].map(item => {
    return item.dataset.title;
  }), 0, 20);

  // Full page
  const anchors = [...workshopSections].map(item => {
    return item.dataset.anchor;
  });
  window.fullPage = Fullpage('#workshop-sections', anchors, {
    onLeave: (origin, destination, direction) => {
      const section = context.querySelector(`[data-anchor='${destination.anchor}']`);

      // Don't allow scroll down if menu is open
      if (window.menu.isOpen && direction === 'down') return false;
      
      // Scroll out of menu
      if (!origin.isLast) {
        let noScroll = window.menu.isOpen;
        window.menu.close(); if (noScroll) return false;
      }
      if (!origin.isLast && window.menu.isOpen) return false;

      // If last 'psudeo' section
      if (destination.isLast) {

        // Open menu
        window.menu.open();

        // Timeout to scrollback to 
        setTimeout(() => {
          window.fullPage.silentMoveTo(origin.anchor);
        }, 700);
      } else {
        
        // Set marquee text
        if (section) titleMarquee.goto(section.dataset.title);

        // Close menu
        if (!origin.isLast) window.menu.close();
      }

      // Active classes on menu
      const menuLinks = context.querySelectorAll('#workshop-menu a');
      menuLinks.forEach(link => {
        if (link.href.includes('workshops#' + destination.anchor)) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });

      // Background color
      document.body.style.backgroundColor = section.dataset.bgcolor;
    }
  });
}


// WEBPACK FOOTER //
// ./source/javascript/sections/workshops.js